var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -3 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-140.000000, -3642.000000)",
    fill: "#D74E5E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.4324393,3487.63833 C95.4094393,3487.61278 95.3924393,3487.58428 95.3674393,3487.55971 L95.3634393,3487.56265 C94.5824393,3486.79509 93.2434393,3486.86683 92.5364393,3487.56167 C91.8294393,3488.25651 91.8314393,3489.64423 92.5384393,3490.33907 C92.5474393,3490.34791 92.5584393,3490.35381 92.5674393,3490.36265 C92.5914393,3490.38722 92.6084393,3490.41671 92.6334393,3490.44128 L92.6364393,3490.43735 C93.4174393,3491.20491 94.7564393,3491.13415 95.4634393,3490.43833 C96.1704393,3489.74349 96.1684393,3488.35577 95.4614393,3487.66093 C95.4524393,3487.65209 95.4414393,3487.64717 95.4324393,3487.63833 M91.1194393,3486.17002 L89.7054393,3484.77936 C87.5844393,3486.86486 87.6834393,3491.13612 89.8044393,3493.22064 L91.2184393,3491.83096 C89.8044393,3490.44128 89.7054393,3487.55971 91.1194393,3486.17002 M88.2914393,3483.38968 L86.8774393,3482 C82.6344393,3486.17002 83.4404393,3492.5258 86.9764393,3496 L88.3904393,3494.61032 C85.5624393,3491.83096 85.4634393,3486.17002 88.2914393,3483.38968 M98.1954393,3484.77936 L96.7814393,3486.17002 C98.1954393,3487.55971 98.2944393,3490.44128 96.8804393,3491.83096 L98.2944393,3493.22064 C100.415439,3491.13612 100.316439,3486.86486 98.1954393,3484.77936 M101.122439,3496 L99.7084393,3494.61032 C102.537439,3491.83096 102.438439,3486.17002 99.6094393,3483.38968 L101.023439,3482 C104.559439,3485.47518 105.365439,3491.83096 101.122439,3496",
    id: "radio_signal-[#1026]"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleRadio);
export default __webpack_public_path__ + "static/media/apple_radio.902b17be15a7885617349d4c59449f14.svg";
export { ForwardRef as ReactComponent };